export const LOAD_KATEGORIEN = 'load_kategorien';
export const LOAD_EINGABEARTEN = 'load_eingabearten';
export const LOAD_INTERVALLARTEN = 'load_intervallarten';
export const LOAD_PRUEFAKTIONEN = 'load_pruefaktionen';
export const LOAD_PROZESSKONTROLLKARTE_STATI = 'load_prozesskontrollkarte_stati';
export const LOAD_FACHBEREICHE = 'load_fachbereiche';
export const LOAD_TEILEGRUPPEN = 'load_teilegruppen';
